var map = {
	"./Article": 54620,
	"./Article/": 54620,
	"./Article/index": 54620,
	"./Article/index.jsx": 54620,
	"./Article/styles.module.css": 50574,
	"./BlankLayout": 30643,
	"./BlankLayout/": 30643,
	"./BlankLayout/index": 30643,
	"./BlankLayout/index.jsx": 30643,
	"./BlankLayout/styles.module.css": 59348,
	"./FooterLayout": 8147,
	"./FooterLayout/": 8147,
	"./FooterLayout/index": 8147,
	"./FooterLayout/index.jsx": 8147,
	"./FooterLayout/styles.module.css": 42113
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39077;